import Hero from "../sections/Hero";
import ProjectMarquee from "../sections/ProjectMarquee";
import SolutionsGrid from "../sections/SolutionsGrid";
import TasFlowSpotlight from "../sections/TasFlowSpotlight";
import CaseStudiesSection from "../sections/CaseStudiesSection";
import SprintTimeline from "../sections/SprintTimeline";
import ScaleCapability from "../sections/ScaleCapability";
import SupportSection from "../sections/SupportSection";
import DrAiSection from "../sections/DrAiSection";
import RoketPartnerSection from "../sections/RoketPartnerSection";
import TrustSection from "../sections/TrustSection";
import BlogTeasers from "../sections/BlogTeasers";
import HomeFaq from "../sections/HomeFaq";
import FinalCta from "../sections/FinalCta";
import SEO from "../components/SEO";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

export default function Home() {
  const { lang } = useLang();
  const seo = HOME_I18N[lang].seo;

  return (
    <>
      <SEO title={seo.title} description={seo.description} />
      <Hero />
      <ProjectMarquee />
      <SolutionsGrid />
      <CaseStudiesSection />
      <TasFlowSpotlight />
      <SprintTimeline />
      <ScaleCapability />
      <SupportSection />
      <DrAiSection />
      <RoketPartnerSection />
      <TrustSection />
      <BlogTeasers />
      <HomeFaq />
      <FinalCta />
    </>
  );
}
